import { connect, Component } from 'macguffin'
import { setBonusComplete } from 'game/redux/actions'
import PropTypes from 'prop-types'

import { Tween } from "@tweenjs/tween.js"

const FADE_IN = "fadeIn"
const FADE_OUT = "fadeOut"

@connect(state => ({
    skipfeature: state.base.skipfeature,
    freespinSummaryComplete: state.game.freespinSummaryComplete }),
    { setBonusComplete })
export default class Fade extends Component {
    static propTypes = {
        freespinSummaryComplete: PropTypes.bool,
        setBonusComplete: PropTypes.func
    }

    state = { showFade: false }

    componentWillReceiveProps(nextProps) {
        const { props: currentProps, allowLeaving} = this

        if (nextProps.freespinSummaryComplete !== currentProps.freespinSummaryComplete) {
            if (nextProps.freespinSummaryComplete) {
                new Tween()
                .to({}, 5000)
                .onComplete(allowLeaving)
                .start()
            }
        }

        if (nextProps.showFade && nextProps.skipfeature && nextProps.skipfeature !== currentProps.skipfeature) {
            this.timeout && this.timeout.stop()
            this.timeout = undefined
            nextProps.setBonusComplete()
            this.setState({ fadeName: undefined, showFade: false })
        }
    }

    render() {
        const { showFade, fadeName } = this.state || {}

        const className = (showFade && fadeName) || undefined
        const style = {
            visibility: showFade ? "visible" : "hidden"
        }

        return (<div key="fader" className={className} style={style} />)
    }

    allowLeaving = () => {
        const { setBonusComplete } = this.props
        this.setState({ showFade: true, fadeName: FADE_IN})

        const timeout = new Tween()
            .to({}, 2100)
            .onComplete(setBonusComplete)


        const timeout2 = new Tween()
            .to({}, 1000)
            .onComplete(() => { this.setState({ fadeName: FADE_OUT }) })


        const timeout3 = new Tween()
            .to({}, 2100)
            .onComplete(() => { this.setState({ fadeName: undefined, showFade: false }) })


        this.timeout = timeout.chain(timeout2).chain(timeout3).start()
    }
}
